const ajax = require('@subiz/ajax/src/ajax.js')
const sb = require('@sb/util')
const bowser = require('bowser')
import {addInstrumentationHandler, resetInstrumentationHandlers} from './instrument.js'

var logreq = ajax.setBaseUrl('https://log.subiz.xyz').withCredentials(true).setContentType('text/plain')

if (typeof window !== 'undefined') window.internalLogs = window.internalLogs || ['thanh']

const SLEEP = 500 //
const BATCH_LOGS_SIZE = 50
const DEBUG_EXPIRED = 2 * 24 * 3600_000 // 2 days

function LogStore({account_id, agent_id}) {
	let me = {}
	const caches = []
	let _log_inserted = false
	const browser_tab_id = 'chrome_session_' + sb.randomString(16)
	function computeConsoleLog(data) {
		// {timestamp} {scope} {level} {hostname} {account-id} {file}:{line} {content...}
		//
		let timestamp = displayUTCLogTime(new Date())
		let scope = 'dashboard'
		let level = data.level
		if (data.level === 'log') level = 'LOG'
		else if (data.level === 'debug') level = 'DEBUG'
		else if (data.level === 'error') level = 'ERROR'
		else if (data.level === 'warn') level = 'WARNING'
		else if (data.level === 'info') level = 'INFO'
		else level = 'LOG'
		let hostname = 'console'

		let args = data.args || []
		let content = ''
		lo.each(args, (arg) => {
			if (typeof arg === 'string') {
				content += `${arg} `
			} else if (typeof arg === 'number') {
				content += `${arg} `
			} else if (typeof arg === 'object') {
				if (arg.stack) {
					content += `${arg.stack} `
				} else {
					content += `${JSON.stringify(arg)} `
				}
			} else {
				content += `${JSON.stringify(arg)} `
			}
		})

		return `${timestamp} ${scope} ${level} dashboard ${account_id} ${hostname} ${agent_id} ${browser_tab_id}: ${content}`
	}

	function computeOnErrorLog(ev) {
		let timestamp = displayUTCLogTime(new Date())
		let scope = 'dashboard'
		let level = 'ERROR'
		let hostname = 'onError'
		let message = `${ev.msg} ${ev.url} ${ev.line}:${ev.column}`
		return `${timestamp} ${scope} ${level} dashboard ${account_id} ${hostname} ${agent_id} ${browser_tab_id}: ${message}`
	}

	function computeXHRLog(xhr) {
		let timestamp = displayUTCLogTime(new Date())
		let scope = 'dashboard'
		let level = 'ERROR'
		let hostname = 'xhr'
		let message = `${xhr.status} ${xhr.responseText}`
		return `${timestamp} ${scope} ${level} dashboard ${account_id} ${hostname} ${agent_id} ${browser_tab_id}: ${message}`
	}

	async function collectQueueLogs() {
		while (true) {
			let logs = caches.splice(0, BATCH_LOGS_SIZE)
			if (!lo.size(logs)) {
				await sb.sleep(SLEEP)
				continue
			}

			let base64Logs = lo.map(logs, (log) => {
				let result = ''
				try {
					// btoa cannot encode latin character, so we need this tricky
					result = btoa(unescape(encodeURIComponent(log)))
				} catch (err) {}
				return result
			})
			base64Logs = lo.filter(base64Logs, Boolean)
			base64Logs = lo.join(base64Logs, '\n')
			await logreq.setQuery({format: 'base64'}).post('/collect', base64Logs)
			await sb.sleep(SLEEP)
		}
	}

	me.postLog = (payload, type) => {
		logreq.post(
			'/collect',
			`${displayUTCLogTime(new Date())} dashboard LOG dashboard ${account_id} store ${type || 'START_LOG'} ${payload}`,
		)
	}

	me.startLog = () => {
		if (_log_inserted) return
		let ua = window.navigator.userAgent
		let browserInfo = ua && bowser.getParser(ua)
		let browserName = lo.get(browserInfo, 'parsedResult.browser.name')
		let browserVer = lo.get(browserInfo, 'parsedResult.browser.version', '')
		let os = lo.get(browserInfo, 'parsedResult.os.name')
		let platform = lo.get(browserInfo, 'parsedResult.platform.type')
		browserName = browserName ? `${browserName} ${browserVer}` : 'Unknow browser'
		let resolution = '?'
		if (window.screen) resolution = `${window.screen.availWidth}x${window.screen.availHeight}`
		let sessionInfo = `${browserName} ${os} ${platform} ${resolution}`
		logreq.post(
			'/collect',
			`${displayUTCLogTime(
				new Date(),
			)} dashboard LOG START_LOG ++++++++++++++++++[${sessionInfo}]++++++++++++++++++++++`,
		)
		collectQueueLogs()
		addInstrumentationHandler('console', function (data) {
			// donot console in this function, infinity loop
			caches.push(computeConsoleLog(data))
		})

		addInstrumentationHandler('error', function (ev) {
			caches.push(computeOnErrorLog(ev))
		})

		addInstrumentationHandler('xhr', function (data) {
			const xhr = data.xhr || {}
			const args = data.args || []
			// ignore xhr.send() instrument
			if (!data.endTimestamp) return
			if (xhr.status >= 400 || xhr.status < 200) {
				let log = computeXHRLog(xhr)
				caches.push(log)
			}
		})
		_log_inserted = true
	}

	me.stopLog = () => {
		if (!_log_inserted) return
		logreq.post(
			'/collect',
			`${displayUTCLogTime(
				new Date(),
			)} dashboard LOG END_LOG ===============================================================`,
		)
		resetInstrumentationHandlers()
		_log_inserted = false
	}

	me.reinit = (data) => {
		account_id = data.account_id
		agent_id = data.agent_id
	}

	return me
}

function displayUTCLogTime(date) {
	let yyyy = date.getUTCFullYear().toString()
	let yy = yyyy.substr(2, 2)
	let mm = date.getUTCMonth() + 1
	let dd = date.getUTCDate()
	let hh = date.getUTCHours()
	let MM = date.getUTCMinutes()
	let ss = date.getUTCSeconds()

	return `${yy}-${pad(mm)}-${pad(dd)} ${pad(hh)}:${pad(MM)}:${pad(ss)}`
}

function pad(v) {
	return v < 10 ? `0${v}` : `${v}`
}

export default LogStore
